import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import { useTranslation } from '../../i18n';
import './DemoNotice.css';

// Bandeau du mode démo (?demo), avec une croix pour en sortir (même page, sans ?demo)
function DemoNotice() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const quitDemo = () => {
        const params = new URLSearchParams(location.search);
        params.delete('demo');
        const search = params.toString();
        navigate(location.pathname + (search ? '?' + search : ''), { replace: true });
    };

    return (
        <div className='demo_notice'>
            <span>{t('playoffs.demo')}</span>
            <button type='button' className='demo_notice_close' onClick={quitDemo} aria-label={t('playoffs.quitDemo')} title={t('playoffs.quitDemo')}>
                <IoClose size={20} />
            </button>
        </div>
    );
}

export default DemoNotice;
